document.addEventListener("DOMContentLoaded", function () {
  const showMoreButtons = document.querySelectorAll(".lbc-show-more__button");

  showMoreButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const contentWrap = button.closest(".product-content-tab__content");
      const truncatedTextEl = contentWrap.querySelector(".truncated-text");
      const truncatedText = truncatedTextEl.getAttribute("data-truncated-text");
      const fullText = truncatedTextEl.getAttribute("data-full-text");

      truncatedTextEl.classList.toggle("truncated-text--active");

      if (truncatedTextEl.classList.contains("truncated-text--active")) {
        truncatedTextEl.innerHTML = fullText;
        button.innerHTML = button.getAttribute("data-show-less");
      } else {
        truncatedTextEl.innerHTML = truncatedText;
        button.innerHTML = button.getAttribute("data-show-more");
      }
    });
  });
});
